import { render, staticRenderFns } from "./ReviewsFilter.vue?vue&type=template&id=fd58e506&"
import script from "./ReviewsFilter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsFilter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewsFilter.vue?vue&type=style&index=0&id=fd58e506&lang=scss&"
import style1 from "./ReviewsFilter.vue?vue&type=style&index=1&id=fd58e506&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd58e506')) {
      api.createRecord('fd58e506', component.options)
    } else {
      api.reload('fd58e506', component.options)
    }
    module.hot.accept("./ReviewsFilter.vue?vue&type=template&id=fd58e506&", function () {
      api.rerender('fd58e506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsFilter/ReviewsFilter.vue"
export default component.exports